import type { RefObject } from 'react'
import { useCallback, useEffect } from 'react'

export const useOutsideClick = (ref: RefObject<any>, callback: (e?: Event) => void) => {
  const handleClick = useCallback(
    (e: Event) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback(e)
      }
    },
    [callback, ref],
  )

  const handleBlur = useCallback(() => {
    if (document.activeElement?.tagName === 'IFRAME') {
      callback()
    }
  }, [callback])

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('touchstart', handleClick)
    window.addEventListener('blur', handleBlur)

    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('touchstart', handleClick)
      window.removeEventListener('blur', handleBlur)
    }
  }, [handleBlur, handleClick])
}
